import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

const FULL_WIDTH = '100%';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	width: 100%;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 0;
	width: ${FULL_WIDTH};
`;

export const ActionsWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const Title = styled.div`
	font-size: 13px;
	line-height: 13px;
	color: ${colors.grey5};
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: ${FULL_WIDTH};
`;
